import './testOrderSummaryViewComponent.scss'
import React from 'react';
import {Grid} from "@mui/material";
import DetailsDataKeyValueComponent
    from "../../../../../shared/components/details-data-key-value-component/detailsDataKeyValueComponent";
import commonService from "../../../../../shared/services/common.service";
import {CommonService} from "../../../../../shared/services";

interface TestOrderSummaryViewComponentProps {
    testOrderDetails: any;
}

const TestOrderSummaryViewComponent = (props: TestOrderSummaryViewComponentProps) => {
        const {testOrderDetails} = props;
        return (

            <div className="testOrder-information-component details-tab-data-content">
                {testOrderDetails && <>
                    <div className="details-tab-data-header">
                        <div className="view-and-edit-title">Patient Details</div>
                        <div className="">
                            {/*<ButtonComponent*/}
                            {/*    className={"white-space-nowrap"}*/}
                            {/*    type="button"*/}
                            {/*    color={"secondary"}*/}
                            {/*    variant={"contained"}*/}
                            {/*    fullWidth={true}*/}
                            {/*    handleClick={onEditModeOpen}*/}
                            {/*>*/}
                            {/*    Edit Details*/}
                            {/*</ButtonComponent>*/}
                        </div>
                    </div>
                    <div className="details-tab-data-body">
                        <Grid container spacing={2} className="pdd-top-0">
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Patient Name"}> {testOrderDetails?.patientDetails?.firstName ? (CommonService.capitalizeFirstLetterOfEachWord(testOrderDetails?.patientDetails?.firstName) + ' ' + CommonService.capitalizeFirstLetterOfEachWord(testOrderDetails.patientDetails?.lastName)) : '-'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Gender"}> {testOrderDetails?.patientDetails?.gender || '-'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Phone Number"}> {testOrderDetails?.patientDetails?.mobileNumber ? commonService.getMaskedMobileNumber(testOrderDetails?.patientDetails?.mobileNumber) : '-'} </DetailsDataKeyValueComponent>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6} xl={6}>
                                <DetailsDataKeyValueComponent
                                    title={"Patient ID"}> {testOrderDetails?.patientDetails?.id || '-'} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Date of Birth"}> {commonService.formatDate(testOrderDetails?.patientDetails?.dateOfBirth)} </DetailsDataKeyValueComponent>
                                <DetailsDataKeyValueComponent
                                    title={"Email ID"}> {testOrderDetails?.patientDetails?.emailId || '-'} </DetailsDataKeyValueComponent>
                            </Grid>
                        </Grid>
                    </div>
                    <div className="horizontal-line"/>
                    <>
                        <div className="view-and-edit-title">Order Details</div>
                        <div className="details-tab-data-body">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Order ID"}> {testOrderDetails?.code || '-'} </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Ordered Test(s)"}>
                                        {testOrderDetails?.samples && testOrderDetails?.samples?.filter((sample:any)=> sample?.orderType === "test")?.length > 0 ? <>
                                                {testOrderDetails?.samples?.filter((sample:any)=> sample?.orderType === "test")?.map((sample: any, index: number) => {
                                                    return <div key={index}>{sample?.testDetails?.name}</div>
                                                })}
                                            </> :
                                            <>NA</>}
                                    </DetailsDataKeyValueComponent>
                                </Grid>
                                <Grid item xs={12} sm={12} md={6} xl={6}>
                                    <DetailsDataKeyValueComponent
                                        title={"Ordering Physician"}> {testOrderDetails?.physicianDetails?.firstName ? (CommonService.capitalizeFirstLetterOfEachWord(testOrderDetails?.physicianDetails?.firstName) + " " + CommonService.capitalizeFirstLetterOfEachWord(testOrderDetails?.physicianDetails?.lastName)) : '-'}  </DetailsDataKeyValueComponent>
                                    <DetailsDataKeyValueComponent
                                        title={"Ordered Test Panel(s)"}>
                                        {testOrderDetails?.samples && testOrderDetails?.samples?.filter((sample:any)=> sample?.orderType === "panel")?.length > 0 ? <>
                                                {testOrderDetails?.samples?.filter((sample:any)=> sample?.orderType === "panel")?.map((sample: any, index: number) => {
                                                    return <div key={index}>{sample?.panelDetails?.name}</div>
                                                })}
                                            </> :
                                            <>NA</>}
                                    </DetailsDataKeyValueComponent>
                                </Grid>
                            </Grid>
                        </div>
                    </>
                </>}
            </div>
        )
    }

;

export default TestOrderSummaryViewComponent;
